import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./RenderHtml.scss"
import { Image } from "antd";
import parse from "html-react-parser";
import ReactDOMServer from 'react-dom/server'
import { useTextHighlighter } from "/src/views/TextHighlighter/HighlighterHelper";

const replaceMathMLWithSpanDataAttribute = (html) => {
  // console.log('RenderHTML =>> html', html);

  const mathMap = {};
  let index = 0;

  // Very specific regex: <math ...>...</math>
  const processedHtml = html.replace(/<math[\s\S]*?<\/math>/g, (match) => {
    const key = `MATH_${index++}`;
    mathMap[key] = match;
    // Wrap in a span so html-react-parser can see it
    return `<math-data data-math-key="${key}"></math-data>`;
  });

  return { processedHtml, mathMap };
};

const RenderHtml = ({ uniqueTextIdentifier = "renderHtml", text, truncate, style, extraClassname = "", replaceItem, renderUsingParse= false}) => {
  console.log("RenderHtml",  replaceItem, renderUsingParse)
  const htmlRef = useRef(null);
  const texthighlighter = useTextHighlighter(htmlRef, uniqueTextIdentifier)

  const processedHtmlResult =
    useMemo(() => {
      if (!text) {
        return '';
      }
      return replaceMathMLWithSpanDataAttribute(text);
    }, [text]);
  if (processedHtmlResult === '') {
    return '';
  }
  const { processedHtml, mathMap } = processedHtmlResult;


 
  const options = {
    replace(node, index) {
      // First, handle math replacement
      if (
        node.type === 'tag' &&
        node.name === 'math-data' &&
        node.attribs &&
        node.attribs['data-math-key']
      ) {
        // console.log('RenderHTML =>> node', node);
        const key = node.attribs['data-math-key'];
        const mathMarkup = mathMap[key];

        if (!mathMarkup) return; // fallback – shouldn't normally happen

        return <span dangerouslySetInnerHTML={{ __html: mathMarkup }} />;
      }

      // Then, run replaceItem if provided
      if (typeof replaceItem === 'function') {
        return replaceItem(node, index);
      }

      return undefined;
    },
  };
  

  return (
    <div
          style={style}
          className={`${extraClassname} ${truncate ? "render-html" : "show-html"}`}
          ref={htmlRef}
          
        >{parse(processedHtml, options)}</div>
  );
};

export default RenderHtml;
